import { connect } from "react-redux";
import React, { Component } from "react";
import {
  getValueFromLanguageObject,
} from "../../../store";
import Breadcrumb from "../../common/breadcrumb";
import { withRouter } from "react-router-dom";
import { getCall } from "../../../api/post";
import {  getTermsandConditionsUrl } from "../../../services";

class TermsConditions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      termsAndConditionsData: '',
      loading: true,
      error: null
    };
  }

  componentDidMount() {
    this.fetchTermsAndConditions();
  }

  // fetchPrivacyPolicy = async () => {
  //   try {
  //     const privacyPolicyUrl = getPrivacyPolicyUrl();
  //     const data = await getCall(privacyPolicyUrl, []);
      
  //     if (data.error) {
  //       throw new Error(data.error.message || 'Failed to fetch privacy policy');
  //     }
      
  //     this.setState({
  //       privacyPolicyData: data.text || '',
  //       loading: false
  //     });
  //   } catch (error) {
  //     console.error('Error fetching privacy policy:', error);
  //     this.setState({
  //       error: error.message,
  //       loading: false
  //     });
  //   }
  // };

   fetchTermsAndConditions = async () => {
    try {
      const termsAndConditionsUrl = getTermsandConditionsUrl();
      const data = await getCall(termsAndConditionsUrl, []);
      
      if (data.error) {
        throw new Error(data.error.message || 'Failed to fetch terms and conditions');
      }

      this.setState({
        termsAndConditionsData: data.text || '',
        loading: false
      });
    } catch (error) {
      console.error('Error fetching terms and conditions:', error);
      this.setState({
        error: error.message,
        loading: false
      });
    }
  };

  render() {
    const { privacyPolicyData, termsAndConditionsData, loading, error } = this.state;

    return (
      <>
        <div>
          <Breadcrumb
            title="Terms & Conditions"
          />
          
          {/* Terms & Conditions section */}
          <section className="terms-section section-b-space">
            <div className="container">
              <div className="row">
                {/* Contact Information Sidebar */}
                <div className="col-lg-3">
                  <div style={{
                    backgroundColor: '#f8f9fa',
                    padding: '30px',
                    borderRadius: '8px',
                    height: 'fit-content'
                  }}>
                    <p style={{ marginBottom: '10px' }}>
                      If you have any questions, please email us at{' '}
                      <a href="mailto:rewards@rezlive.com" style={{ color: '#f39e1d' }}>
                        rewards@rezlive.com
                      </a>
                    </p>
                  </div>
                </div>

                {/* Terms & Conditions Content */}
                <div className="col-lg-9">
                  <div className="terms-content">
                    <h3 style={{ 
                      fontWeight: 'bold', 
                      marginBottom: '30px',
                      color: '#333'
                    }}>
                      Terms & Conditions
                    </h3>
                    
                    {loading ? (
                      <div style={{ textAlign: 'center', padding: '50px' }}>
                        <p>Loading privacy policy...</p>
                      </div>
                    ) : error ? (
                      <div style={{ 
                        backgroundColor: '#f8d7da', 
                        border: '1px solid #f5c6cb',
                        color: '#721c24',
                        padding: '15px',
                        borderRadius: '5px',
                        marginBottom: '20px'
                      }}>
                        <p>Error loading privacy policy: {error}</p>
                      </div>
                    ) : (
                      <div 
                        style={{ fontSize: '15px', lineHeight: '1.6', color: '#333' }}
                        dangerouslySetInnerHTML={{ __html: termsAndConditionsData }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(
  mapStateToProps,
  {}
)(withRouter(TermsConditions));
